import { render, staticRenderFns } from "./edit-partner-rrp-form.vue?vue&type=template&id=646175fc&scoped=true&"
import script from "./edit-partner-rrp-form.vue?vue&type=script&lang=js&"
export * from "./edit-partner-rrp-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner-rrp-form.vue?vue&type=style&index=0&id=646175fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646175fc",
  null
  
)

export default component.exports